import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const tokenRequiredGuard = (): CanActivateFn => {
  return (route) => {
    const router = inject(Router);
    const token = route.queryParamMap.get('token')?.trim();

    if (!token) {
      return router.createUrlTree(['/error']);
    }

    return true;
  };
};
